import './Tab.scss';
import clsx from 'clsx';
import { constNull } from 'fp-ts/lib/function';
import React, { memo, PropsWithChildren, ReactNode, useContext } from 'react';
import { TabsContext } from 'src/modules/common/components/Tabs';
import { Tooltip } from 'src/modules/common/components/Tooltip';

export type TabProps = PropsWithChildren & {
  index?: number;
  size?: 'md' | 'lg';
  theme?: 'gray' | 'white';
  disabled?: boolean;
  bordered?: boolean;
  tooltipValue?: ReactNode;
  onClick?: () => void;
};

export const Tab = memo(({
  index = 0,
  size = 'md',
  theme = 'gray',
  bordered,
  disabled,
  tooltipValue,
  children,
  onClick,
}: TabProps) => {
  const { activeTab, setActiveTab } = useContext(TabsContext);

  const handleClick = (): void => {
    onClick?.();
    setActiveTab(index);
  };

  return (
    <Tooltip id={`bp-tab-${index}`} value={tooltipValue} disabled={!tooltipValue}>
      <div
        className={clsx({
          'bp-tab': true,
          'bp-tab--active': index === activeTab,
          'bp-tab--disabled': disabled,
          'bp-tab--bordered': bordered,
          [`bp-tab--${size}`]: true,
          [`bp-tab--${theme}`]: true,
        })}
        onClick={disabled ? constNull : handleClick}
        role="tab"
        onKeyDown={() => null}
        tabIndex={0}
      >
        {children}
      </div>
    </Tooltip>
  );
});
